module.exports = __webpack_public_path__ + "img/button6.6f03e603.png";